// extracted by mini-css-extract-plugin
export default {"schedule-alert__container":"styles_schedule-alert__container__emRsI"};